import { render, staticRenderFns } from "./CAAG1020.vue?vue&type=template&id=b3859830&scoped=true"
import script from "./CAAG1020Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAAG1020Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CAAG1020.vue?vue&type=style&index=0&id=b3859830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3859830",
  null
  
)

export default component.exports